import { Skeleton, Stack } from "@mui/material";
import React from "react";

const CustomerInfoSkeleton = () => {
  return (
    <div className="customer-info-content">
      <Stack spacing={1}>
        <div className="customer-name">
          <Skeleton width={"50%"} height={20} animation="wave" />
        </div>
        <div className="customer-email">
          <Skeleton width={"100%"} height={20} animation="wave" />
        </div>
        <div className="customer-contact-no" style={{ display: "flex" }}>
          Contact No{" "}
          <span style={{ width: "50%", marginLeft: "5px" }}>
            <Skeleton width={"100%"} height={20} animation="wave" />
          </span>
        </div>
      </Stack>
    </div>
  );
};

export default CustomerInfoSkeleton;
